export const clientCrmEn = {
  pageTitle: 'Client',
  clientDetails: 'Client details',
  tripTitle: 'Trip title',
  tripInfo: 'Trip info',
  tripInfoPlaceholder: 'e.g. Hawaii honeymoon, Europe summer 2026',
  name: {
    firstName: 'First name',
    lastName: 'Last name',
  },
  contact: {
    sectionTitle: 'Contact',
    mobilePhone: 'Mobile',
    workPhone: 'Work phone',
    homePhone: 'Home phone',
    personalEmail: 'Personal email',
    workEmail: 'Work email',
    preferredContactMethod: 'Preferred contact',
    preferredContact: {
      email: 'Email',
      phone: 'Voice',
      text: 'Text',
    },
  },
  address: {
    sectionTitle: 'Address',
    line1: 'Address line 1',
    line2: 'Address line 2',
    city: 'City',
    state: 'State',
    zip: 'ZIP',
    country: 'Country',
  },
  workAddress: {
    sectionTitle: 'Work address',
    line1: 'Address line 1',
    line2: 'Address line 2',
    city: 'City',
    state: 'State',
    zip: 'ZIP',
    country: 'Country',
  },
  passport: {
    sectionTitle: 'Passport',
    number: 'Passport number',
    countryOfIssue: 'Country of issue',
    dateOfIssue: 'Date of issue',
    dateOfExpiry: 'Date of expiry',
    placeOfBirth: 'Place of birth',
  },
  driversLicense: {
    sectionTitle: "Driver's license",
    number: 'License number',
    state: 'State',
    expiration: 'Expiration',
  },
  loyaltyPrograms: {
    sectionTitle: 'Loyalty programs',
    placeholder: 'One per line: airline, car rental, hotel programs...',
    programPlaceholder: 'Program (e.g. United, Hilton)',
    numberPlaceholder: 'Member number',
    preferred: 'Preferred',
    addProgram: 'Add loyalty program',
  },
  trip: {
    sectionTitle: 'Trip details',
    destinations: 'Destinations',
    destinationsPlaceholder: 'Select cities (filters List Builder in itinerary)',
    addTrip: 'Add trip',
    editTrip: 'Edit trip',
    planItinerary: 'Plan itinerary',
    startDate: 'Start date',
    endDate: 'End date',
    groupSize: 'Group size',
    adults: 'Adults',
    children: 'Children',
    childrenAges: "Children's ages",
    childrenAgesPlaceholder: 'e.g. 5, 8',
    tripDates: 'Trip dates',
    tripType: 'Trip type',
    tripTypeOptions: {
      organized_tour: 'Organized Tour',
      cruise: 'Cruise',
      business: 'Business Trip',
      backpacking: 'Backpacking',
      luxury: 'Luxury Vacation',
      adventure: 'Adventure Trip',
      cultural: 'Cultural Trip',
      other: 'Other',
    },
  },
  preferences: {
    sectionTitle: 'Preferences',
    airClass: 'Air class',
    airClassOptions: { any: 'Any', business: 'Business', first: 'First' },
    food: 'Food preferences',
    foodOptions: {
      vegetarian: 'Vegetarian',
      vegan: 'Vegan',
      'gluten-free': 'Gluten-free',
      'dairy-free': 'Dairy-free',
      kosher: 'Kosher',
      halal: 'Halal',
      'low-carb': 'Low carb',
      pescatarian: 'Pescatarian',
      none: 'None',
    },
    activityPreferences: 'Activity preferences',
    activityOptions: {
      museums: 'Museums',
      outdoor: 'Outdoor',
      cultural: 'Cultural',
      food: 'Food',
      shopping: 'Shopping',
      nightlife: 'Nightlife',
      adventure: 'Adventure',
      relaxation: 'Relaxation',
      history: 'History',
      art: 'Art',
    },
    accommodationType: 'Accommodation type',
    accommodationOptions: {
      boutique: 'Boutique',
      luxury: 'Luxury',
      budget: 'Budget',
      chain: 'Chain',
      resort: 'Resort',
      'home-rental': 'Home rental',
    },
    accommodationBudget: 'Accommodation budget/night ($)',
    travelStyle: 'Travel style',
    travelStyleOptions: {
      relaxed: 'Relaxed',
      moderate: 'Moderate',
      'fast-paced': 'Fast-paced',
    },
  },
  travelCompanions: {
    sectionTitle: 'Travel companions',
    addCompanion: 'Add companion',
    remove: 'Remove',
    firstName: 'First name',
    lastName: 'Last name',
    relationship: 'Relationship',
    relationshipOptions: {
      spouse: 'Spouse',
      child: 'Child',
      parent: 'Parent',
      sibling: 'Sibling',
      friend: 'Friend',
      coworker: 'Co-worker',
      other: 'Other',
    },
    age: 'Age',
  },
  notes: {
    sectionTitle: 'Notes',
    addNote: 'Add note',
    placeholder: 'Enter a note...',
    noNotes: 'No notes yet.',
  },
  trips: {
    sectionTitle: 'Trips',
    noTrips: 'No trips yet.',
    addFirst: 'Add your first trip.',
  },
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    back: 'Back',
  },
} as const;
